import { css, StyleDeclarationValue } from 'aphrodite';
import { LoadingSpinner } from '../../components/LoadingSpinner';
import { AIStarsIcon } from '../../components/svgs/icons/AIStars';
import { styleSheet } from './styles';

export const AiButton = ({
	title,
	isLoading,
	onClick,
	disabled,
	size = 'default',
	styles = [],
}: {
	title?: string;
	isLoading?: boolean;
	onClick?: () => void;
	disabled?: boolean;
	size?: 'default' | 'sm' | 'xs';
	styles?: StyleDeclarationValue[];
}) => {
	const isDisabled = isLoading || disabled;

	return (
		<button disabled={isDisabled} onClick={onClick} className={css(styleSheet.button, styleSheet[size], ...styles)}>
			{
				<>
					{isLoading ? <LoadingSpinner type='tiny' /> : <AIStarsIcon stopColorOne='white' stopColorTwo='white' />}
					{title && <span>{title}</span>}
				</>
			}
		</button>
	);
};
